import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label
} from "reactstrap";
import {
  Route,
  BrowserRouter,
  NavLink,
  Switch,
  browserHistory,
  withRouter
} from "react-router-dom";
import createHistory from "history/createBrowserHistory";
class OrderId extends React.Component {
  constructor(props) {
    super(props);
    console.log("OrderIdProps", props);
    this.state = { modal: false };
    this.toggle = this.toggle.bind(this);
    const history = createHistory();
    const unlisten = history.listen((location, action) => {
      if (this.state.modal) {
        this.setState({ modal: false });
      }
    });
  }
  toggle(data, e) {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    return (
      <div>
        <BrowserRouter>
          <div>
            <NavLink
              className="spn-jobs-item-box-number"
              to="/assigned/canceljob"
              onClick={this.toggle}
            >
              {this.props.totalOrder}
            </NavLink>

            <Switch>
              <Route path="/assigned/canceljob">
                <Modal
                  isOpen={this.state.modal}
                  backdrop={"static"}
                  keyboard={false}
                  fade={false}
                  toggle={this.toggle}
                  className={this.props.className}
                >
                  <ModalHeader className="justify-content-center py-2 alert-secondary">
                    Order Id
                  </ModalHeader>
                  <ModalBody className="text-center">
                    {this.props.orderids &&
                      this.props.orderids.map(obj => <div k={obj}>{obj}</div>)}
                  </ModalBody>
                  <ModalFooter className="p-0 border-0">
                    <span className="col-6 text-center">
                      <NavLink
                        className="btn m-0 py-2"
                        exact
                        to="/assigned"
                        onClick={this.toggle}
                      >
                        OK
                      </NavLink>
                    </span>{" "}
                  </ModalFooter>
                </Modal>
              </Route>
            </Switch>
          </div>
        </BrowserRouter>
      </div>
    );
  }
}

export default OrderId;



// WEBPACK FOOTER //
// ./src/components/Assigned/OrderId.js